import SvgChecklist from "@Components/CustomIcon/SvgChecklist"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { MaterialIcons } from "@expo/vector-icons"
import React from "react"
import { StyleSheet, TouchableOpacity, View } from "react-native"

export const ReportCardItem = (props) => {
    return (
        <TouchableOpacity activeOpacity={0.8} style={styles.touchable} onPress={() => props.onPress && props.onPress()}>
            <View style={styles.cardContainer}>
                <View style={styles.cardRow}>
                    <View style={styles.cardCol}>
                        <SvgChecklist height={27} width={27} />
                    </View>

                    <View style={{ flex: 1, paddingStart: 20 }}>
                        <OpenSansText color={baseColors.black} fontSize={14}>
                            {props.title}
                        </OpenSansText>
                        <OpenSansText color={baseColors.black} fontSize={14}>
                            Date : le {props.date}
                        </OpenSansText>
                    </View>

                    <MaterialIcons color={baseColors.green.primary} size={28} name={"chevron-right"} />
                </View>
            </View>
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    touchable: { borderRadius: 10, marginBottom: 10 },
    cardContainer: {
        alignContent: "center",
        justifyContent: "center",
        backgroundColor: baseColors.green.light,
        height: 81,
        borderRadius: 10,
        padding: 10
    },
    cardRow: {
        flexDirection: "row",
        alignContent: "center",
        justifyContent: "space-between",
        alignItems: "center"
    },
    cardCol: {
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 10,
        width: 47,
        height: 47,
        backgroundColor: "white"
    }
})
